
import { Vue } from "vue-class-component";

export default class PriorityFast extends Vue {}
